import React, { useEffect, useState } from "react";
import { Box, Skeleton } from "@mui/material";
import { fetchPlacementAds } from "../services/dataService";
import { BANNER_BORDER, CARD_RADIUS } from "../styles/tokens";

// TODO: Посмотреть, нужно ли изменять эти значения
const BANNER_HEIGHT = 240; // Максимальная высота баннера в пикселях (примерно как у карточек событий)
export const BANNER_MAX_WIDTH = 700; // Максимальная ширина баннера на мобильных (совпадает с шириной карточек событий)
const BANNER_ASPECT_RATIO = 600 / 240; // Соотношение сторон контейнера баннера на мобильных
// На десктопе (≥ md) баннер во всю ширину контента, высота BANNER_HEIGHT, изображение обрезается по центру

const BannerPlacement = ({ placement, token, loading: externalLoading = false }) => {
  const [banner, setBanner] = useState(null);
  const [loading, setLoading] = useState(false);
  // Файл баннера не загрузился (404 и т.п.) — не показываем пустую рамку
  const [mediaFailed, setMediaFailed] = useState(false);

  useEffect(() => {
    setMediaFailed(false);
  }, [banner?.media_url]);

  useEffect(() => {
    let cancelled = false;

    const loadBanner = async () => {
      if (!token || !placement) {
        setBanner(null);
        setLoading(false);
        return;
      }

      try {
        setLoading(true);
        const ads = await fetchPlacementAds(token, placement);
        if (cancelled) return;
        setBanner(ads?.[0] || null);
      } catch (error) {
        console.error("Ошибка загрузки баннера:", error);
        if (!cancelled) {
          setBanner(null);
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    };

    if (externalLoading) {
      setLoading(true);
      return () => {
        cancelled = true;
      };
    }

    loadBanner();

    return () => {
      cancelled = true;
    };
  }, [placement, token, externalLoading]);

  if (loading) {
    return (
      <Box sx={{ width: "100%" }}>
        <Skeleton
          variant="rounded"
          height={BANNER_HEIGHT}
          sx={{ borderRadius: CARD_RADIUS, backgroundColor: "rgba(255,255,255,0.08)" }}
        />
      </Box>
    );
  }

  if (!banner || mediaFailed) {
    return null;
  }

  const handleMediaError = () => {
    console.error("Не удалось загрузить файл баннера:", banner.media_url);
    setMediaFailed(true);
  };

  const mediaElement =
    banner.media_type === "video" ? (
      <Box
        component="video"
        src={banner.media_url}
        onError={handleMediaError}
        autoPlay
        loop
        muted
        playsInline
        sx={{
          width: "100%",
          height: "100%",
          maxWidth: "100%",
          maxHeight: "100%",
          objectFit: "cover",
          objectPosition: "center",
          borderRadius: CARD_RADIUS,
          display: "block",
        }}
      />
    ) : (
      <Box
        component="img"
        src={banner.media_url}
        alt={banner.title || ""}
        loading="lazy"
        onError={handleMediaError}
        sx={{
          width: "100%",
          height: "100%",
          maxWidth: "100%",
          maxHeight: "100%",
          objectFit: "cover",
          objectPosition: "center",
          borderRadius: CARD_RADIUS,
          display: "block",
        }}
      />
    );

  const Wrapper = banner.redirect_url ? "a" : "div";

  return (
    <Box sx={{ width: "100%" }}>
      <Box
        component={Wrapper}
        href={banner.redirect_url || undefined}
        target={banner.redirect_url ? "_blank" : undefined}
        rel={banner.redirect_url ? "noopener noreferrer" : undefined}
        sx={{
          display: "block",
          position: "relative",
          width: "100%",
          aspectRatio: { xs: BANNER_ASPECT_RATIO, md: "auto" },
          height: { md: `${BANNER_HEIGHT}px` },
          maxWidth: { xs: `${BANNER_MAX_WIDTH}px`, md: "none" },
          maxHeight: `${BANNER_HEIGHT}px`,
          borderRadius: CARD_RADIUS,
          overflow: "hidden",
          background: "rgba(255,255,255,0.05)",
          border: BANNER_BORDER,
          transition: "transform 0.2s ease, box-shadow 0.2s ease",
          ":hover": banner.redirect_url
            ? {
                transform: "translateY(-2px)",
                boxShadow: "0 12px 30px rgba(0,0,0,0.35)",
              }
            : undefined,
        }}
      >
        {mediaElement}
      </Box>
    </Box>
  );
};

export default BannerPlacement;

